import { AnimatedPage, AnimatedPageHeader } from '@components/index'
import { UsersForm } from '@features/users/components/UsersForm'
import { usePatchProfile } from '@services/users/mutations/usePatchProfile'
import { useUploadPhoto } from '@services/users/mutations/useUploadPhoto'
import { useProfile } from '@services/users/queries/useProfile'
import { useProfilePhoto } from '@services/users/queries/useProfilePhoto'
import { useTranslation } from 'react-i18next'
import { UserDetail } from 'types/api'

export const defaultDateFormat = 'YYYY-MM-DD'

export function User() {
  const { data, isLoading } = useProfile(true)
  const { data: profilePhoto, isLoading: profilePhotoLoading } =
    useProfilePhoto()
  const { mutate: patchFromData } = usePatchProfile()
  const { mutate: uploadPhoto } = useUploadPhoto()
  const { t } = useTranslation('users')

  function submitForm(values: UserDetail) {
    // birth_date already arrives as an ISO `YYYY-MM-DD` string from DatePicker.
    if (values.phone) {
      values.phone = values.phone.replace(/\s/g, '')
    }

    // A cleared degree must be sent as null — `undefined` is dropped by JSON
    // and the backend would keep the old value.
    patchFromData({ ...values, degree: values.degree ?? null } as UserDetail)
  }

  if (isLoading && profilePhotoLoading) {
    return <div>{t('loading')}</div>
  }

  return (
    <AnimatedPage>
      <div className="flex justify-center">
        <div className="containerSmall">
          <AnimatedPageHeader
            title={t('editProfile')}
            description={t('profileDescription')}
          />
          <UsersForm
            profilePhoto={profilePhoto}
            uploadPhoto={uploadPhoto}
            submitForm={submitForm}
            data={data}
            hideEmployment={data?.role === 'LANDLORD'}
          />
        </div>
      </div>
    </AnimatedPage>
  )
}
